import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class AuthGuard {
  authService = inject(AuthService);
  protected router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      this.authService.redirectToLoginPage();
    } else {
      this.authService.loadCurrentUser();
    }

    // Auth service will handle redirects
    return this.authService.currentUser$.pipe(map(() => true));
  }
}
